import React, {memo} from "react";
import PropTypes from "prop-types";
import {Box, Button, Typography} from "@mui/material";
import {PageTitle, StyledTooltip} from "../../components";
import AddIcon from "@mui/icons-material/Add";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {useRexAITrustedAdvisorStyles} from "./useRexAITrustedAdvisorStyles";

const SessionListHeader = ({onCreateNew}) => {
  const {classes} = useRexAITrustedAdvisorStyles();

  return (
    <Box p={2} pb={1}>
      <PageTitle>
        Rex AI
        <Typography component="span" className={classes.trademark}>
          &reg;
        </Typography>
        {" "}
        Maestro
        <StyledTooltip

          title="Rex AI agents can make mistakes. BreachRx doesn't use your workspace data to train any models."
          placement="right"
        >
          <InfoOutlinedIcon color="primary" className={classes.infoIcon} />
        </StyledTooltip>
      </PageTitle>
      <Box display="flex" alignItems="center" gap={0.5} mb={2}>
        <Typography variant="caption" color="text.secondary">
          Your AI agent for incident response
        </Typography>
      </Box>
      <Button fullWidth variant="contained" startIcon={<AddIcon />} onClick={onCreateNew}>
        New Conversation
      </Button>
    </Box>
  );
};

SessionListHeader.propTypes = {
  onCreateNew: PropTypes.func.isRequired,
};

export default memo(SessionListHeader);
